import Vue from "vue";
import * as MUTATIONS from "../config/constants/mutation-types";

export default {
  /**
   * Mutation llamada por el router
   * Ponemos la ruta en el state
   * @param {Object} state
   * @param {Object} payload
   */
  [MUTATIONS.ON_ROUTE]: (state, payload) => {
    Vue.set(state, "route", payload);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Boolean} payload estado
   */
  [MUTATIONS.ON_IS_LOADING]: (state, payload) => {
    Vue.set(state, "isLoading", !!payload);
  },
  /**
   * Adobe App Started
   * @param {Object} context
   * @param {String} nombre elemento
   */
  [MUTATIONS.ON_ADOBE_APPSTARTED]: (state, payload) => {
    Vue.set(state, "trackClickElement", payload);
  },
  /**
   * Mutation disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} state
   */
  [MUTATIONS.ON_LANDING]: (state, payload) => {
    Vue.set(state, "landing", payload);
  },
  [MUTATIONS.ON_PASO_1]: (state, payload) => {
    Vue.set(state, "paso1", payload);
  },
  [MUTATIONS.ON_GRACIAS]: (state, payload) => {
    Vue.set(state, "gracias", payload);
  }
};
